import isInAnyVariant from './isInAnyVariant'

// CAT-3829
const IBAN_FAKE_SECRET_IDS = [
  {
    id: 568,
    env: 'shared'
  },
  {
    id: 1134,
    env: 'stage'
  },
  {
    id: 1117,
    env: 'live'
  }
]
export const isInIbanFakeSecretVariant = () =>
  isInAnyVariant(IBAN_FAKE_SECRET_IDS)

// CAT-2
const STRUCTURAL_TEST_VARIANT_B = [
  {
    id: 583,
    env: 'shared'
  },
  {
    id: 1163,
    env: 'stage'
  },
  {
    id: 1167,
    env: 'live'
  }
]

export const isInStructuralTestVariantB = () =>
  isInAnyVariant(STRUCTURAL_TEST_VARIANT_B)

// CAT-2
const STRUCTURAL_TEST_VARIANT_C = [
  {
    id: 584,
    env: 'shared'
  },
  {
    id: 1165,
    env: 'stage'
  },
  {
    id: 1168,
    env: 'live'
  }
]

export const isInStructuralTestVariantC = () =>
  isInAnyVariant(STRUCTURAL_TEST_VARIANT_C)

// CAT-1006
const AB_TEST_CONTACT_PAGE = [
  {
    id: 601,
    env: 'shared'
  },
  {
    id: 1207,
    env: 'stage'
  },
  {
    id: 1184,
    env: 'production'
  }
]

export const isInABTestContactPageVariantB = () =>
  isInAnyVariant(AB_TEST_CONTACT_PAGE)
